import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
import type { Quarter } from "@/types/entities";
export type { DashboardSummary, AtRiskKr, QuarterCompletion, TeamDashboardSummary, TeamCompletion } from "@/types/entities";

export function useEmployeeDashboard(year?: number) {
  return useQuery({
    queryKey: ["dashboard", "employee", year],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/dashboard", {
        params: { query: { year } },
      });
      if (error) throw new Error(error.error.message);
      return data;
    },
  });
}

export function useTeamDashboard(year?: number, quarter?: Quarter) {
  return useQuery({
    queryKey: ["dashboard", "team", year, quarter],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/dashboard/team", {
        params: { query: { year, quarter } },
      });
      if (error) throw new Error(error.error.message);
      return data;
    },
  });
}
